import Typography from "@mui/material/Typography";
import React from "react";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Grid from "@mui/material/Grid";
import AvatarIcon from "../assets/icons/avatar.svg";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import MarkunreadMailboxOutlinedIcon from "@mui/icons-material/MarkunreadMailboxOutlined";
import {AVATAR_BASE_URL_API, BASE_URL_API} from "../Const";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MuiAlert from "@mui/material/Alert";
import {Snackbar} from "@mui/material";
import {BackButton, BottomMenu} from "./HookUtils";
import IconButton from "@mui/material/IconButton";
import L from "leaflet";
import customMarkerIconUrl from "../assets/icons/current-location.png";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";

import Cropper from "react-easy-crop";
import heic2any from "heic2any";

import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const customLocationIcon = L.icon({
    iconUrl: customMarkerIconUrl,
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
});

const MAX_AVATAR_SIZE = 2 * 1024 * 1024; // 2MB

export class ProfileComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: null,
            name: null,
            address: null,
            postalcode: null,
            openSnackbar: false,
            message: "",
            snackbarType: "success",
            lat: null,
            lng: null,
            showMapModal: false,

            uploadingAvatar: false,
            avatarProgress: 0,

            // انتخاب منبع تصویر
            showAvatarSourceDialog: false,

            // کراپر
            showCropDialog: false,
            cropImageSrc: null,
            cropImageObjectUrl: null, // برای revoke کردن
            crop: {x: 0, y: 0},
            zoom: 1,
            croppedAreaPixels: null,
            isPreparingAvatar: false
        };

        this._map = null;
        this._marker = null;

        this.avatarCameraInputRef = React.createRef();
        this.avatarGalleryInputRef = React.createRef();
    }

    componentDidMount() {
        this.getUserData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.showMapModal && this.state.showMapModal) {
            setTimeout(() => {
                const Llocal = require("leaflet");
                const lat = this.state.lat || 35.6892;
                const lng = this.state.lng || 51.389;

                if (this._map) {
                    this._map.remove();
                }

                this._map = Llocal.map("leafletMap").setView([lat, lng], 13);

                Llocal.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                    attribution: "&copy; OpenStreetMap contributors",
                }).addTo(this._map);

                this._marker = Llocal
                    .marker([lat, lng], {icon: customLocationIcon})
                    .addTo(this._map);

                this._map.on("click", (e) => {
                    const {lat, lng} = e.latlng;
                    this._marker.setLatLng([lat, lng]);
                    this.setState({lat, lng});
                });
            }, 200);
        }
    }

    // --------------------------
    // Location
    // --------------------------
    handleShowCurrentLocation = () => {
        if (!navigator.geolocation) {
            this.getFallbackIPLocation();
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                this.updateMapLocation(lat, lng);
            },
            (err) => {
                console.error("Geo error:", err);
                this.getFallbackIPLocation();
            },
            {
                enableHighAccuracy: true,
                timeout: 8000,
                maximumAge: 0,
            }
        );
    };

    updateMapLocation = (lat, lng) => {
        this.setState({lat, lng}, () => {
            if (this._map && this._marker) {
                this._map.setView([lat, lng], 15);
                this._marker.setLatLng([lat, lng]);
            }
        });
    };

    getFallbackIPLocation = async () => {
        try {
            const res = await fetch("http://ip-api.com/json/");
            const data = await res.json();
            console.log("IP-based location:", data);

            if (data.status === "success") {
                const lat = data.lat;
                const lng = data.lon;

                this.updateMapLocation(lat, lng);
                alert("«این موقعیت تقریبی است و ممکن است دقیق نباشد.»");
            } else {
                alert("موقعیت شما قابل دریافت نیست (اطلاعات IP غیرقابل استفاده بود).");
            }
        } catch (e) {
            console.error("IP geo failed:", e);
            alert("موقعیت شما قابل دریافت نیست (حتی با IP).");
        }
    };

    // --------------------------
    // User data
    // --------------------------
    getUserData() {
        fetch(BASE_URL_API + "user", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((results) => {
                if (results.code === "200") {
                    this.setState({
                        userData: results.data,
                        name: results.data.name,
                        address: results.data.address,
                        postalcode: results.data.postalcode,
                        lat: results.data.lat,
                        lng: results.data.lng,
                    });
                }
            });
    }

    updateLocationOnly = () => {
        const {lat, lng} = this.state;

        if (!lat || !lng) {
            alert("لطفاً روی نقشه یک نقطه انتخاب کنید!");
            return;
        }

        fetch(BASE_URL_API + "user", {
            method: "PUT",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({lat, lng}),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result.code === "200") {
                    this.getUserData();

                    this.setState({
                        showMapModal: false,
                        openSnackbar: true,
                        message: "موقعیت با موفقیت ذخیره شد.",
                        snackbarType: "success",
                    });
                } else {
                    this.setState({
                        openSnackbar: true,
                        message: result.message || "خطا در ذخیره موقعیت.",
                        snackbarType: "error",
                    });
                }
            })
            .catch(() => {
                this.setState({
                    openSnackbar: true,
                    message: "ارتباط با سرور برقرار نشد.",
                    snackbarType: "error",
                });
            });
    };

    // --------------------------
    // Avatar: select source
    // --------------------------
    handleAvatarButtonClick = () => {
        if (this.state.uploadingAvatar) return;
        this.setState({showAvatarSourceDialog: true});
    };

    handleChooseCamera = () => {
        this.setState({showAvatarSourceDialog: false}, () => {
            if (this.avatarCameraInputRef.current) {
                this.avatarCameraInputRef.current.click();
            }
        });
    };

    handleChooseGallery = () => {
        this.setState({showAvatarSourceDialog: false}, () => {
            if (this.avatarGalleryInputRef.current) {
                this.avatarGalleryInputRef.current.click();
            }
        });
    };

    // --------------------------
    // Avatar: file → crop dialog
    // --------------------------
    handleAvatarFileChange = async (event) => {
        let file = event.target.files[0];
        if (!file) return;

        const mime = (file.type || "").toLowerCase();
        const name = (file.name || "").toLowerCase();

        try {
            // شروع پردازش → دایالوگ لودینگ را روشن کن
            this.setState({isPreparingAvatar: true});

            // ✅ اگر HEIC / HEIF بود → تبدیل به JPG
            const isHeic =
                mime === "image/heic" ||
                mime === "image/heif" ||
                name.endsWith(".heic") ||
                name.endsWith(".heif");

            if (isHeic) {
                const convertedBlob = await heic2any({
                    blob: file,
                    toType: "image/jpeg",
                    quality: 0.9,
                });

                file = new File([convertedBlob], "avatar.jpg", {
                    type: "image/jpeg",
                });
            }

            // ✅ چک اینکه حتماً تصویر باشد
            if (!file.type.startsWith("image/")) {
                this.setState({
                    openSnackbar: true,
                    message: "لطفاً یک فایل تصویری معتبر انتخاب کنید.",
                    snackbarType: "error",
                });
                return;
            }

            // ✅ ساخت object URL و باز کردن کراپر
            const objectUrl = URL.createObjectURL(file);

            this.setState({
                cropImageSrc: objectUrl,
                cropImageObjectUrl: objectUrl,
                showCropDialog: true,
                crop: {x: 0, y: 0},
                zoom: 1.2,
                croppedAreaPixels: null,
            });
        } catch (error) {
            console.error("HEIC convert / prepare error:", error);
            this.setState({
                openSnackbar: true,
                message:
                    "خطا در آماده‌سازی تصویر. لطفاً دوباره تلاش کنید یا تصویر دیگری انتخاب کنید.",
                snackbarType: "error",
            });
        } finally {
            // دایالوگ لودینگ را ببند
            this.setState({isPreparingAvatar: false});
            event.target.value = "";
        }
    };

    onCropComplete = (croppedArea, croppedAreaPixels) => {
        this.setState({croppedAreaPixels});
    };

    // پاک کردن object URL بعد از بستن کراپر
    cleanupCropImageUrl = () => {
        if (this.state.cropImageObjectUrl) {
            URL.revokeObjectURL(this.state.cropImageObjectUrl);
        }
        this.setState({
            cropImageObjectUrl: null,
            cropImageSrc: null,
            showCropDialog: false,
        });
    };

    // --------------------------
    // Crop helpers
    // --------------------------
    getCroppedImg = (imageSrc, croppedAreaPixels) => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            // برای object URL نیازی به crossOrigin نیست
            image.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                const {width, height, x, y} = croppedAreaPixels;

                canvas.width = width;
                canvas.height = height;

                ctx.drawImage(
                    image,
                    x,
                    y,
                    width,
                    height,
                    0,
                    0,
                    width,
                    height
                );

                canvas.toBlob(
                    (blob) => {
                        if (!blob) {
                            reject(new Error("Canvas is empty"));
                            return;
                        }
                        resolve(blob);
                    },
                    "image/jpeg",
                    0.9
                );
            };
            image.onerror = (e) => reject(e);
            image.src = imageSrc;
        });
    };

    compressImageIfNeeded = (blob) => {
        return new Promise((resolve, reject) => {
            if (blob.size <= MAX_AVATAR_SIZE) {
                return resolve(blob);
            }

            const img = new Image();
            const url = URL.createObjectURL(blob);

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                const maxDimension = 1024;
                let {width, height} = img;

                const ratio = Math.min(maxDimension / width, maxDimension / height, 1);
                width = width * ratio;
                height = height * ratio;

                canvas.width = width;
                canvas.height = height;

                ctx.drawImage(img, 0, 0, width, height);

                let quality = 0.9;

                const tryCompress = () => {
                    canvas.toBlob(
                        (newBlob) => {
                            if (!newBlob) {
                                reject(new Error("compress failed"));
                                return;
                            }

                            if (newBlob.size <= MAX_AVATAR_SIZE || quality <= 0.4) {
                                URL.revokeObjectURL(url);
                                resolve(newBlob);
                            } else {
                                quality -= 0.1;
                                canvas.toBlob(
                                    (b) => {
                                        if (!b) {
                                            reject(new Error("compress failed"));
                                            return;
                                        }
                                        if (b.size <= MAX_AVATAR_SIZE || quality <= 0.4) {
                                            URL.revokeObjectURL(url);
                                            resolve(b);
                                        } else {
                                            quality -= 0.1;
                                            tryCompress();
                                        }
                                    },
                                    "image/jpeg",
                                    quality
                                );
                            }
                        },
                        "image/jpeg",
                        quality
                    );
                };

                tryCompress();
            };

            img.onerror = (e) => {
                URL.revokeObjectURL(url);
                reject(e);
            };

            img.src = url;
        });
    };

    handleConfirmCropAndUpload = async () => {
        const { cropImageSrc, croppedAreaPixels } = this.state;

        if (!cropImageSrc || !croppedAreaPixels) {
            this.setState({
                openSnackbar: true,
                message: "ابتدا ناحیه‌ی برش را انتخاب کنید.",
                snackbarType: "error",
            });
            return;
        }

        try {
            // ✅ بلافاصله دایالوگ کراپ را ببند
            this.setState({
                showCropDialog: false,
            });

            // 1️⃣ ساخت Blob کراپ‌شده
            const croppedBlob = await this.getCroppedImg(
                cropImageSrc,
                croppedAreaPixels
            );

            // 2️⃣ فشرده‌سازی در صورت نیاز
            const finalBlob = await this.compressImageIfNeeded(croppedBlob);

            // 3️⃣ شروع آپلود (progress روی آواتار نمایش داده می‌شود)
            await this.uploadAvatar(finalBlob);

            // 4️⃣ پاک‌سازی object URL
            if (this.state.cropImageObjectUrl) {
                URL.revokeObjectURL(this.state.cropImageObjectUrl);
            }

            this.setState({
                cropImageSrc: null,
                cropImageObjectUrl: null,
            });

        } catch (e) {
            console.error(e);
            this.setState({
                openSnackbar: true,
                message: "خطا در پردازش تصویر.",
                snackbarType: "error",
            });
        }
    };

    uploadAvatar = (blob) => {
        return new Promise((resolve) => {
            const token = localStorage.getItem("pwa_token");
            if (!token) {
                this.setState({
                    openSnackbar: true,
                    message: "ابتدا وارد حساب کاربری خود شوید.",
                    snackbarType: "error",
                });
                return resolve();
            }

            const formData = new FormData();
            formData.append("avatar", blob, "avatar.jpg");

            const xhr = new XMLHttpRequest();
            xhr.open("POST", BASE_URL_API + "uploadAvatar", true);
            xhr.setRequestHeader("Authorization", "Bearer " + token);
            xhr.setRequestHeader("Accept", "application/json");

            this.setState({uploadingAvatar: true, avatarProgress: 0});

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percent = Math.round(
                        (event.loaded / event.total) * 100
                    );
                    this.setState({avatarProgress: percent});
                }
            };

            xhr.onload = () => {
                let success = false;
                if (xhr.status === 200) {
                    try {
                        const res = JSON.parse(xhr.responseText);
                        if (res.code === "200") {
                            success = true;
                            this.getUserData();
                            this.setState({
                                openSnackbar: true,
                                message: "تصویر پروفایل با موفقیت به‌روزرسانی شد.",
                                snackbarType: "success",
                            });
                        } else {
                            this.setState({
                                openSnackbar: true,
                                message: res.message || "خطا در آپلود تصویر.",
                                snackbarType: "error",
                            });
                        }
                    } catch (e) {
                        this.setState({
                            openSnackbar: true,
                            message: "پاسخ سرور قابل خواندن نیست.",
                            snackbarType: "error",
                        });
                    }
                } else {
                    this.setState({
                        openSnackbar: true,
                        message: "خطا در ارتباط با سرور هنگام آپلود تصویر.",
                        snackbarType: "error",
                    });
                }

                this.setState({
                    uploadingAvatar: false,
                    avatarProgress: success ? 100 : 0,
                });

                if (success) {
                    setTimeout(() => {
                        this.setState({avatarProgress: 0});
                    }, 500);
                }

                resolve();
            };

            xhr.onerror = () => {
                this.setState({
                    uploadingAvatar: false,
                    avatarProgress: 0,
                    openSnackbar: true,
                    message: "خطا در ارسال تصویر به سرور.",
                    snackbarType: "error",
                });
                resolve();
            };

            xhr.send(formData);
        });
    };

    // --------------------------
    // render
    // --------------------------
    render() {
        const handleCloseSnackbar = () => {
            this.setState({openSnackbar: false});
        };

        const onUpdateProfileClicked = () => {
            fetch(BASE_URL_API + "user", {
                method: "PUT",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    name: this.state.name,
                    address: this.state.address,
                    postalcode: this.state.postalcode,
                    lat: this.state.lat,
                    lng: this.state.lng,
                }),
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.code === "200") {
                        this.getUserData();
                        this.setState({
                            userData: result.data,
                            openSnackbar: true,
                            message: "حساب کاربری با موفقیت ویرایش شد.",
                            snackbarType: "success",
                        });

                        setTimeout(() => {
                            window.history.back();
                        }, 500);
                    } else {
                        this.setState({
                            openSnackbar: true,
                            message: result.message,
                            snackbarType: "error",
                        });
                    }
                });
        };

        return (
            <React.Fragment>
                <AppBar style={{background: "rgba(238,238,238,0.3)"}}>
                    <ToolbarMui>
                        <IconButton style={{color: "black"}} size="large">
                            <AccountCircleIcon/>
                        </IconButton>
                        <ListItemText align="center">
                            <strong style={{fontSize: 18, color: "black"}}>
                                پروفایل
                            </strong>
                        </ListItemText>
                        <BackButton/>
                    </ToolbarMui>
                </AppBar>

                <div
                    style={{
                        width: "100%",
                        marginTop: 72,
                        paddingBottom: 90,
                    }}
                    align="center"
                >
                    <Grid container justifyContent="center">
                        {!this.state.userData ? null : (
                            <React.Fragment>
                                {/* Avatar */}
                                <Grid item xs={12} style={{marginTop: 8}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                        }}
                                    >
                                        <img
                                            alt="avatar"
                                            src={
                                                this.state.userData?.picture?.url &&
                                                this.state.userData.picture.url.trim() !== ""
                                                    ? AVATAR_BASE_URL_API + this.state.userData.picture.url
                                                    : AvatarIcon
                                            }
                                            style={{
                                                borderRadius: "50%",
                                                width: 96,
                                                height: 96,
                                                margin: 8,
                                                objectFit: "cover",
                                            }}
                                        />

                                        {this.state.uploadingAvatar && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: 8,
                                                    left: "50%",
                                                    transform:
                                                        "translateX(-50%)",
                                                    width: 96,
                                                    height: 96,
                                                    borderRadius: "50%",
                                                    backgroundColor:
                                                        "rgba(0,0,0,0.4)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <CircularProgress
                                                    variant={
                                                        this.state
                                                            .avatarProgress > 0
                                                            ? "determinate"
                                                            : "indeterminate"
                                                    }
                                                    value={
                                                        this.state
                                                            .avatarProgress
                                                    }
                                                    size={60}
                                                    thickness={4}
                                                    style={{color: "#fff"}}
                                                />
                                            </div>
                                        )}

                                        <IconButton
                                            size="small"
                                            onClick={this.handleAvatarButtonClick}
                                            style={{
                                                position: "absolute",
                                                bottom: 2,
                                                right: 2,
                                                backgroundColor: "#fff",
                                                boxShadow:
                                                    "0 0 6px rgba(0,0,0,0.3)",
                                                padding: 4,
                                            }}
                                        >
                                            <AddAPhotoIcon fontSize="small"/>
                                        </IconButton>

                                        {/* Camera input */}
                                        <input
                                            type="file"
                                            accept="image/jpeg,image/png,image/jpg"
                                            capture="environment"
                                            ref={this.avatarCameraInputRef}
                                            style={{display: "none"}}
                                            onChange={this.handleAvatarFileChange}
                                        />

                                        {/* Gallery input */}
                                        <input
                                            type="file"
                                            accept="image/jpeg,image/png,image/jpg"
                                            ref={this.avatarGalleryInputRef}
                                            style={{display: "none"}}
                                            onChange={this.handleAvatarFileChange}
                                        />
                                    </div>
                                </Grid>

                                {/* Phone + wallet */}
                                <Grid item xs={12}>
                                    <Typography
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: 18,
                                        }}
                                    >
                                        شماره تلفن:{" "}
                                        {this.state.userData.phone}
                                    </Typography>
                                </Grid>


                                <Grid item xs={12} sx={{ mb: 2 }}>
                                    {this.state.isUserLoading ? (
                                        // 🔄 Loading skeleton while wallet is fetching
                                        <Skeleton
                                            variant="rounded"
                                            height={56}
                                            sx={{ borderRadius: 2 }}
                                        />
                                    ) : (
                                        (() => {
                                            const rawWallet = this.state.userData?.wallet ?? 0;
                                            const walletNumber = Number(rawWallet) || 0;
                                            const isNegative = walletNumber < 0;

                                            const mainColor = isNegative ? "#d32f2f" : "#2e7d32";
                                            const borderColor = isNegative ? "#ef9a9a" : "#81c784";
                                            const bgTint = isNegative
                                                ? "rgba(211,47,47,0.06)"
                                                : "rgba(46,125,50,0.06)";

                                            return (
                                                <Box
                                                    sx={{
                                                        p: 1.5,
                                                        borderRadius: 2,
                                                        border: "1px solid rgba(0,0,0,0.06)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        direction: "rtl",
                                                        transition: "all 0.2s ease",
                                                        backgroundColor: "rgba(255,255,255,0.96)",
                                                        "&:hover": {
                                                            boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                                                            borderColor,
                                                            transform: "translateY(-1px)",
                                                        },
                                                    }}
                                                >
                                                    {/* Left side: icon + labels */}
                                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                                        {/* Circular bordered icon */}
                                                        <Box
                                                            sx={{
                                                                width: 36,
                                                                height: 36,
                                                                borderRadius: "50%",
                                                                border: `1.5px solid ${borderColor}`,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                ml: 1.5, // RTL: space between icon and text
                                                                backgroundColor: bgTint,
                                                            }}
                                                        >
                                                            <AccountBalanceWalletOutlinedIcon
                                                                sx={{ fontSize: 20, color: mainColor }}
                                                            />
                                                        </Box>

                                                        {/* Text block */}
                                                        <Box>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 12,
                                                                    color: "text.secondary",
                                                                    mb: 0.3,
                                                                }}
                                                            >
                                                                موجودی کیف پول
                                                            </Typography>

                                                            <Typography
                                                                sx={{
                                                                    fontWeight: 700,
                                                                    fontSize: 15,
                                                                    color: mainColor,
                                                                }}
                                                            >
                                                                {walletNumber.toLocaleString("fa-IR")} تومان
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    {/* Right side: status tag for negative */}
                                                    {isNegative && (
                                                        <Typography
                                                            sx={{
                                                                fontSize: 11,
                                                                fontWeight: 600,
                                                                color: "#d32f2f",
                                                                px: 1.2,
                                                                py: 0.5,
                                                                borderRadius: 999,
                                                                border: "1px solid rgba(211,47,47,0.3)",
                                                                backgroundColor: "rgba(211,47,47,0.04)",
                                                            }}
                                                        >
                                                            بدهی
                                                        </Typography>
                                                    )}
                                                </Box>
                                            );
                                        })()
                                    )}
                                </Grid>

                                {/* Name */}
                                <Grid
                                    item
                                    xs={12}
                                    style={{paddingInline: 24}}
                                >
                                    <TextField
                                        fullWidth
                                        placeholder="نام و نام خانوادگی"
                                        defaultValue={this.state.name}
                                        onChange={(e) =>
                                            this.setState({
                                                name: e.target.value,
                                            })
                                        }
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <PersonOutlineIcon/>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>

                                {/* Postal code */}
                                <Grid
                                    item
                                    xs={12}
                                    style={{paddingInline: 24, marginTop: 16}}
                                >
                                    <TextField
                                        fullWidth
                                        value={this.state.postalcode || ""}
                                        placeholder="کد پستی"
                                        inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[0-9]*",
                                            maxLength: 10,
                                        }}
                                        onChange={(e) => {
                                            const onlyNumbers =
                                                e.target.value.replace(
                                                    /\D/g,
                                                    ""
                                                );
                                            this.setState({
                                                postalcode:
                                                    onlyNumbers.slice(0, 10),
                                            });
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment
                                                    position="start"
                                                    sx={{
                                                        alignSelf: "center",   // ✅ prevents vertical jump
                                                        height: "100%",        // ✅ keeps center alignment
                                                    }}
                                                >
                                                    <MarkunreadMailboxOutlinedIcon/>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>

                                {/* Address */}
                                <Grid
                                    item
                                    xs={12}
                                    style={{paddingInline: 24, marginTop: 16}}
                                >
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        placeholder="آدرس"
                                        defaultValue={this.state.address}
                                        onChange={(e) =>
                                            this.setState({
                                                address: e.target.value,
                                            })
                                        }
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment
                                                    position="end"
                                                    sx={{
                                                        alignSelf: "center",   // ✅ prevents vertical jump
                                                        height: "100%",        // ✅ keeps center alignment
                                                    }}
                                                >
                                                    <ApartmentOutlinedIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            "& .MuiInputAdornment-root": {
                                                alignSelf: "center",   // ✅ extra safety for all themes
                                            },
                                        }}
                                    />

                                </Grid>

                                {/* Location */}
                                <Grid
                                    item
                                    xs={12}
                                    style={{paddingInline: 24, marginTop: 16}}
                                >
                                    <TextField
                                        fullWidth
                                        onClick={() =>
                                            this.setState({
                                                showMapModal: true,
                                            })
                                        }
                                        placeholder="انتخاب موقعیت روی نقشه"
                                        variant="outlined"
                                        InputProps={{
                                            readOnly: true,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <EditLocationAltIcon/>
                                                </InputAdornment>
                                            ),
                                        }}
                                        style={{
                                            cursor: "pointer",
                                            borderRadius: 8,
                                            backgroundColor:
                                                this.state.lat &&
                                                this.state.lng
                                                    ? "#e8f5e9"
                                                    : "#fff",
                                            transition: "all 0.3s ease",
                                        }}
                                        value={
                                            this.state.lat &&
                                            this.state.lng
                                                ? `موقعیت انتخاب شده (${parseFloat(
                                                this.state.lat
                                                ).toFixed(4)}, ${parseFloat(
                                                this.state.lng
                                                ).toFixed(4)})`
                                                : ""
                                        }
                                    />
                                </Grid>

                                {/* Submit */}
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        marginTop: 40,
                                        marginBottom: 16,
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        onClick={onUpdateProfileClicked}
                                        style={{
                                            backgroundColor: "#FF1744",
                                            color: "white",
                                            width: "60%",
                                            maxWidth: 260,
                                        }}
                                    >
                                        ویرایش
                                    </Button>
                                </Grid>
                            </React.Fragment>
                        )}
                    </Grid>

                    <Snackbar
                        open={this.state.openSnackbar}
                        autoHideDuration={6000}
                        onClose={handleCloseSnackbar}
                    >
                        <Alert
                            onClose={handleCloseSnackbar}
                            severity={this.state.snackbarType}
                        >
                            {this.state.message}
                        </Alert>
                    </Snackbar>
                </div>

                {/* Leaflet Modal */}
                {this.state.showMapModal && (
                    <div
                        onClick={() =>
                            this.setState({showMapModal: false})
                        }
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0,0,0,0.7)",
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                width: "90%",
                                height: "75vh",
                                backgroundColor: "#fff",
                                borderRadius: 8,
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden",
                            }}
                        >
                            <div id="leafletMap" style={{flex: 1}}></div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: 12,
                                    borderTop: "1px solid #ccc",
                                    backgroundColor: "#f8f8f8",
                                }}
                            >
                                <Button
                                    onClick={this.handleShowCurrentLocation}
                                    variant="outlined"
                                    color="info"
                                >
                                    موقعیت من
                                </Button>

                                <div
                                    style={{
                                        display: "flex",
                                        gap: "12px",
                                    }}
                                >
                                    <Button
                                        onClick={() =>
                                            this.setState({
                                                showMapModal: false,
                                            })
                                        }
                                        variant="outlined"
                                        color="secondary"
                                    >
                                        بستن
                                    </Button>

                                    <Button
                                        onClick={() => {
                                            if (
                                                this.state.lat &&
                                                this.state.lng
                                            ) {
                                                this.setState({
                                                    showMapModal: false,
                                                });
                                                this.updateLocationOnly();
                                            } else {
                                                alert(
                                                    "لطفاً روی نقشه یک نقطه انتخاب کنید!"
                                                );
                                            }
                                        }}
                                        variant="contained"
                                        color="primary"
                                    >
                                        انتخاب موقعیت
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Dialog: camera / gallery */}
                <Dialog
                    open={this.state.showAvatarSourceDialog}
                    onClose={() =>
                        this.setState({showAvatarSourceDialog: false})
                    }
                    fullWidth
                    maxWidth="xs"
                    PaperProps={{
                        style: {
                            borderRadius: 16,
                            paddingBottom: 8,
                        },
                    }}
                >
                    <DialogTitle
                        style={{
                            textAlign: "center",
                            fontWeight: "bold",
                        }}
                    >
                        انتخاب روش ثبت تصویر
                    </DialogTitle>
                    <DialogContent style={{paddingTop: 0}}>
                        <List>
                            <ListItemButton onClick={this.handleChooseCamera}>
                                <ListItemIcon>
                                    <CameraAltIcon/>
                                </ListItemIcon>
                                <ListItemText
                                    primary="گرفتن عکس با دوربین"
                                    secondary="استفاده از دوربین گوشی"
                                />
                            </ListItemButton>
                            <Divider/>
                            <ListItemButton onClick={this.handleChooseGallery}>
                                <ListItemIcon>
                                    <PhotoLibraryIcon/>
                                </ListItemIcon>
                                <ListItemText
                                    primary="انتخاب از گالری"
                                    secondary="انتخاب تصویر موجود در گوشی"
                                />
                            </ListItemButton>
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() =>
                                this.setState({showAvatarSourceDialog: false})
                            }
                            color="secondary"
                        >
                            انصراف
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog: circular cropper */}
                <Dialog
                    open={this.state.showCropDialog}
                    onClose={this.cleanupCropImageUrl}
                    fullWidth
                    maxWidth="xs"
                    PaperProps={{
                        style: {
                            borderRadius: 16,
                            overflow: "hidden",
                        },
                    }}
                >
                    <DialogTitle
                        style={{
                            textAlign: "center",
                            fontWeight: "bold",
                        }}
                    >
                        برش تصویر پروفایل
                    </DialogTitle>
                    <DialogContent
                        style={{
                            position: "relative",
                            width: "100%",
                            height: 300,
                            background: "#000",
                        }}
                    >
                        {this.state.cropImageSrc && (
                            <Cropper
                                image={this.state.cropImageSrc}
                                crop={this.state.crop}
                                zoom={this.state.zoom}
                                aspect={1}
                                cropShape="round"
                                showGrid={false}
                                onCropChange={(crop) =>
                                    this.setState({crop})
                                }
                                onZoomChange={(zoom) =>
                                    this.setState({zoom})
                                }
                                onCropComplete={this.onCropComplete}
                            />
                        )}
                    </DialogContent>
                    <DialogActions
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            paddingInline: 16,
                        }}
                    >
                        <Button
                            onClick={this.cleanupCropImageUrl}
                            color="secondary"
                        >
                            انصراف
                        </Button>
                        <Button
                            onClick={this.handleConfirmCropAndUpload}
                            variant="contained"
                            color="primary"
                        >
                            تأیید و آپلود
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog: آماده‌سازی تصویر (تبدیل HEIC / لود اولیه) */}
                <Dialog
                    open={this.state.isPreparingAvatar}
                    PaperProps={{
                        style: {
                            borderRadius: 16,
                            padding: 24,
                            textAlign: "center",
                        },
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 16,
                        }}
                    >
                        <CircularProgress/>
                        <Typography style={{fontWeight: 500, fontSize: 15}}>
                            در حال آماده‌سازی تصویر پروفایل...
                        </Typography>
                        <Typography style={{fontSize: 12, color: "#666"}}>
                            لطفاً چند لحظه صبر کنید.
                        </Typography>
                    </div>
                </Dialog>

                <BottomMenu/>
            </React.Fragment>
        );
    }
}
